// extracted by mini-css-extract-plugin
module.exports = {"onecol-four-stories-container":"_2FH5w","wrapper":"_33tmR","first-wrapper":"tOK20"};